import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { TestimonialProps } from "../types/testimonials";

export const useTrackerTestimonials = (): TestimonialProps[] => {
    const { t } = useTranslation("trackerTestimonials");

    // Get testimonials from current language
    const testimonials = t("testimonials", { returnObjects: true }) as Array<{
        quote: string;
        name: string;
        role: string;
    }>;

    // Safety check
    if (!Array.isArray(testimonials)) {
        return trackerTestimonials;
    }

    // Map to TestimonialProps format
    return testimonials.map((item, index) => ({
        quote: item.quote,
        name: item.name,
        role: item.role,
        avatar: `/public/media/landing/avatar${index + 8}.png`,
        rating: index === 2 || index === 4 ? 4 : 5,
        index,
    }));
};

// Export static data for backward compatibility (optional)
export const trackerTestimonials: TestimonialProps[] = [
    {
        quote: "ردیاب دلبند برای فرزندم فوق‌العاده است! همیشه می‌دانم کجاست و با قابلیت موقعیت مکانی دقیق، خیالم راحت است.",
        name: "مادر نگران",
        role: "والد",
        avatar: "/public/media/landing/avatar8.png",
        rating: 5,
        index: 0,
    },
    {
        quote: "هشدار خروج از محدوده برای حیوان خانگی‌ام یک نجات‌دهنده است. دیگر نگران گم شدن سگم نیستم.",
        name: "صاحب حیوان خانگی",
        role: "کاربر ردیاب",
        avatar: "/public/media/landing/avatar9.png",
        rating: 5,
        index: 1,
    },
    {
        quote: "با قابلیت اشتراک‌گذاری با خانواده، همه اعضای خانواده می‌توانند موقعیت فرزندمان را پیگیری کنند. بسیار کاربردی است.",
        name: "خانواده فعال",
        role: "والدین",
        avatar: "/public/media/landing/avatar10.png",
        rating: 4,
        index: 2,
    },
    {
        quote: "تماس اضطراری SOS در ردیاب کودک، آرامش خاطر زیادی به من می‌دهد. می‌دانم که فرزندم در مواقع ضروری می‌تواند کمک بخواهد.",
        name: "پدر دلسوز",
        role: "والد",
        avatar: "/public/media/landing/avatar11.png",
        rating: 5,
        index: 3,
    },
    {
        quote: "قابلیت جستجوی دستگاه برای وسایل ارزشمندم عالی است. کیف پولم را گم کرده بودم و به راحتی پیدایش کردم.",
        name: "کاربر حرفه‌ای",
        role: "کاربر ردیاب",
        avatar: "/public/media/landing/avatar12.png",
        rating: 4,
        index: 4,
    },
    {
        quote: "اعلان‌های هوشمند ردیاب، من را از وضعیت باتری و فعالیت‌های غیرعادی مطلع می‌کند. یک ابزار امنیتی کامل.",
        name: "مدیر امنیت",
        role: "کاربر ردیاب",
        avatar: "/public/media/landing/avatar1.png",
        rating: 5,
        index: 5,
    },
];
